export const PLATFORM_ANDROID = 'android';
export const PLATFORM_BROWSER = 'browser';
export const PLATFORM_IOS = 'ios';

export const IS_MOBILE = window.innerWidth <= 460;

export const EMAIL = 'info@media4care.de';

export const MIXPANEL_TOKEN = process.env.MIXPANEL_TOKEN;

export const ANALYTICS_SPECS = {
    DIARY: {
        NAME: 'diary',
        EVENTS: {
            SELECT_PICTURE: 'select picture diary',
            SEND_PICTURE: 'send picture diary',
            TAKE_PICTURE: 'take picture diary',
            IMAGE_CAPTION: 'image caption diary',
            SELECT_CONTACT: 'select picture contact diary',
            CONFIRM_SEND_PICTURE: 'confirm send picture diary',
            START_VIDEO_CALL: 'start videocall',
            SELECT_VIDEO_CALL_CONTACT: 'select videocall contact',
            END_VIDEO_CALL: 'end videocall',
            DELETE_IMAGE: 'delete image diary',
            CONFIRM_IMAGE_DELETE: 'confirm image deletion diary',
            CANCEL_IMAGE_DELETE: 'cancel image deletion diary'
        }
    },
    MESSAGING: {
        NAME: 'messaging',
        EVENTS: {
            SELECT_MESSAGE_CONTACT: 'select messaging contact',
            SEND_MESSAGE: 'send message',
            TAP_PICTURE_ICON: 'tap picture icon messaging',
            TAKE_PICTURE: 'take picture messaging',
            SELECT_PICTURE: 'select picture messaging',
            SEND_PICTURE: 'send picture messaging'
        }
    },
    MEMBERS: {
        NAME: 'members',
        EVENTS: {
            OPEN_INVITE_CONTACT_SCREEN: 'invite contact screen',
            SEND_INVITE: 'send invite',
            DELETE_CONTACT: 'delete contact',
            LOGOUT: 'log out'
        }
    }
};

